import { render, staticRenderFns } from "./OrderArgument.vue?vue&type=template&id=8e414fce&scoped=true&"
import script from "./OrderArgument.vue?vue&type=script&lang=js&"
export * from "./OrderArgument.vue?vue&type=script&lang=js&"
import style0 from "./OrderArgument.vue?vue&type=style&index=0&id=8e414fce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e414fce",
  null
  
)

export default component.exports